module.exports = __webpack_public_path__ + "static/fonts/fontello.e73a064.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/mavon-editor/dist/font/fontello.eot
// module id = QSTu
// module chunks = 1